import { Button, type ButtonProps } from 'antd'

type PrimaryButtonProps = Omit<ButtonProps, 'color' | 'variant'> & {
  color?:
    | 'danger'
    | 'purple'
    | 'default'
    | 'primary'
    | 'blue'
    | 'cyan'
    | 'green'
    | 'magenta'
    | 'pink'
    | 'red'
    | 'orange'
    | 'yellow'
    | 'volcano'
    | 'geekblue'
    | 'lime'
    | 'gold'
    | undefined
  variant?:
    | 'link'
    | 'text'
    | 'solid'
    | 'outlined'
    | 'dashed'
    | 'filled'
    | undefined
}

export const PrimaryButton = ({
  color = 'purple',
  variant = 'solid',
  ...rest
}: PrimaryButtonProps) => <Button color={color} variant={variant} {...rest} />
